import { Slide } from 'react-awesome-reveal';

const NotFound = () => (
  <Slide direction="left">
    <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
      <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-14">
        <h1 className="text-white text-center">404</h1>
      </div>
    </div>
  </Slide>
);

export default NotFound;
